export const SET = 'REPORT_SETTING.SET';


// WEBPACK FOOTER //
// ./src/constants/ReportSetting.ts